<template>
  <div>
    <vue-good-table
      :rows="articles"
      :columns="tableColumns"
      @on-row-click="click"
      styleClass="vgt-table"
      :sort-options="{
        enabled: false,
      }"
    >
      <template v-slot:table-row="props">

        <span v-if="props.column.field == 'title'">
          <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <span :style="`color: ${value(props.row).channel_content_type.content_type.color}`">
              <icon
                v-tooltip="value(props.row).channel_content_type.content_type.name"
                :icon="value(props.row).channel_content_type.content_type.icon"
                class="mr-1"
              />
            </span>
            <icon
              v-if="props.row.submitted_by"
              v-tooltip.top="'Submitted for review'"
              icon="tick"
              class="text-success d-inline-block"
            />
            <span>
              {{ articleHeader(value(props.row)) }}
            </span>
            <span v-if="props.row.article_id && showRepublish">
              <b style="font-size:10px; color: indianred"> Republish </b>
            </span>
          </div>
        </span>
        <span v-if="props.column.field == 'analysts'">
          <div class="d-flex" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
            <div
              v-for="analyst in reverse(value(props.row).analysts)"
              :key="analyst.id"
              class="article__analyst"
              style="width: 24px;height: 24px;"
            >
              <img
                v-tooltip.top="analyst.user.name"
                :src="`${analyst.user.picture_url ? replaceCdn(analyst.user.picture_url) : 'https://cdn.tellimer.com/analysts/default-tellimer.svg'}`"
                class="rounded-circle img-circle-bg border-white article__analyst__img"
                width="24"
              >
            </div>
          </div>
        </span>
        <span v-if="props.column.field == 'provider'">
          <img
            v-if="value(props.row).channel_content_type"
            v-tooltip.top="value(props.row).channel_content_type.channel.name"
            height="24"
            class="mr-1"
            :src="value(props.row).channel_content_type.channel.logo_url ? replaceCdn(value(props.row).channel_content_type.channel.logo_url) : ''"
          >
        </span>
        <span v-if="props.column.field == 'updated'">
          <div
            style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
            v-if="value(props.row).updated_at"
            v-date="{ date: value(props.row).updated_at, format: $settings.dateTimeFormat }"
          />
        </span>
        <span v-if="props.column.field == 'published'">
          <div
            v-if="value(props.row).published_at"
            v-date="{ date: value(props.row).published_at, format: $settings.dateTimeFormat, isIso: true }"
            style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;"
          />
        </span>
        <span v-if="props.column.field === 'menu'">
          <dropdown
            alignment="right"
            trigger="click"
            class="no-chev"
            @click.native.stop
          >
            <button
              slot="trigger"
              v-if="showDraftEdit(props) || showArticleEdit(props) || showAlerts(props) || showDelete(props) || showRestore(props)"
              class="btn btn-link mr-3 no-chev"
            >
              <icon icon="more-vertical" />
            </button>

            <dropdown-option v-if="showDraftEdit(props)"
                :href="$router.resolve({ name: 'articles.draft', params: { draftId: props.row._id } }).href"
                style="text-decoration: none;margin: 2px;"
            >
                <icon icon="edit" /> Edit
            </dropdown-option>
            <dropdown-option v-if="showArticleEdit(props)"
                :href="$router.resolve({ name: 'articles.edit', params: { articleId: props.row.id } }).href"
                style="text-decoration: none;margin: 2px;"
            >
                <icon icon="edit" /> Edit
            </dropdown-option>
            <dropdown-option v-if="showAlerts(props)"
                style="text-decoration: none;"
                href="javascript:;"
                @click.native="$emit('show-alerts', value(props.row).id)"
            >
                <icon icon="alerts" /> Alerts
            </dropdown-option>
            <dropdown-option v-if="showDelete(props)"
                style="text-decoration: none;"
                href="javascript:;"
                @click.native="$emit('delete', (props.row))"
            >
                <icon icon="delete" /> Delete
            </dropdown-option>
            <dropdown-option v-if="showRestore(props)"
                v-tooltip.top="'Restore'"
                href="javascript:;"
                @click.native="restore(props.row)"
            >
                <i class="sl-arrow-up-circle" /> Restore
            </dropdown-option>
          </dropdown>
        </span>
      </template>
    </vue-good-table>

    <pagination
      :data="pagination"
      :disabled="isLoading"
      @change-page="(p) => $emit('change-page', p)"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { VueGoodTable } from 'vue-good-table'
import Date from '@/directives/date'
import mixin from './Mixin'

import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  mixins: [mixin],
  directives: {
    Date,
  },
  components: {
    Pagination,
    Dropdown,
    DropdownOption,
    VueGoodTable,
  },
  props: {
    value: {
      required: false,
      type: Function,
      default (v) {
        return v
      },
    },
    articles: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: false,
      default: null,
    },
    isDraftsList: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableColumns: [
        {field: 'title', label: 'Title', width: '50%'},
        {field: 'analysts', label: 'Analysts', width: '100px'},
        {field: 'provider', label: 'Provider', width: '100px'},
        {
          field: this.isDraftsList ? 'updated' : 'published',
          label: this.isDraftsList ? 'Last Updated At': 'Published At',
          width: '100px',
        },
        {field: 'menu', width: '1px'},
      ]
    }

  },

  computed: {
    showRepublish() {
      return this.$login.isEditor()
    }
  },

  methods: {
    click ({row}) {
      if (row.article_id && this.showRepublish) {
        this.$router.push({
          name: 'articles.republish',
          params: {
            articleId: row.article_id
          }
        })
      } else if (row.latest_revision) {
        this.$router.push({
          name: 'articles.draft',
          params: {
            draftId: row.id,
          },
        })
      } else {
        this.$router.push({
          name: 'articles.view',
          params: {
            articleId: row.id,
          },
        })
      }
    },
    reverse (analysts) {
      return [...analysts].reverse()
    },
    showDraftEdit (scope) {
      return this.isDraftsList && (this.$login.can('article-drafts.update') || this.$login.can('article-drafts.update.mine')) && (this.value(scope.row)._id !== null && this.value(scope.row)._id !== undefined)
    },
    showArticleEdit () {
      return !this.isDraftsList && this.$login.can('articles.update')
    },
    showAlerts (scope) {
      this.$login.can('alerts.view') && this.value(scope.row).deleted_at === null
    },
    showDelete (scope) {
      return (this.isDraftsList && (this.$login.can('article-drafts.delete') || this.$login.can('article-drafts.delete.mine')))
        || (!this.isDraftsList && this.$login.can('articles.delete'))
        && (this.value(scope.row).deleted_at === undefined || this.value(scope.row).deleted_at === null)
    },
    showRestore (scope) {
      return this.$login.can('articles.delete') && this.value(scope.row).deleted_at !== undefined && this.value(scope.row).deleted_at !== null
    },

    replaceCdn(s) {
      return s.replace('s3-eu-west-1.amazonaws.com/exotix-cdn/', 'cdn.tellimer.com/')
    },
  },
}
</script>

<style lang="scss">
</style>


